import _ from "lodash";

const onReSize = ({ dispatch }) => {
  const screenWidth = _.get(window, "innerWidth", 1920);
  dispatch({ type: "CHANGE_WindowScreenSize", payload: screenWidth });
};

const onLoad = (store) => {
  const { dispatch } = store;
  onReSize(store);
  dispatch({ type: "INITIAL" });
};

const root = (store) => {
  window.addEventListener("resize", () => onReSize(store));
  window.addEventListener("load", () => onLoad(store));
  window.addEventListener("error", (e) => {
    if (
      e.message === "ResizeObserver loop limit exceeded" ||
      e.message ===
        "ResizeObserver loop completed with undelivered notifications."
    ) {
      const resizeObserverErrDiv = document.getElementById(
        "webpack-dev-server-client-overlay-div"
      );
      const resizeObserverErr = document.getElementById(
        "webpack-dev-server-client-overlay"
      );
      if (resizeObserverErr)
        resizeObserverErr.setAttribute("style", "display: none");
      if (resizeObserverErrDiv)
        resizeObserverErrDiv.setAttribute("style", "display: none");
    }
  });
};

export default root;
